import loading from "../assets/images/loading.svg";

const Loading = () => (
  <div className="spinner" style={{background: '#353a40'}}>
    <img src={loading} alt="Loading" />
  </div>
);

export default Loading;
